module.exports = __webpack_public_path__ + "static/media/_MIC2485.thumbnail.9be29ea5.png";